import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DOMAIN_NUMBER_STR: InjectionToken<string> = new InjectionToken<string>('domainNumberStr');
